module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-90deg-down-54662e39.svg";